import * as React from 'react';
import { withStyles, WithStyles } from '@material-ui/core/styles';
import Popover from '@material-ui/core/Popover';
import { FMButtonBase } from 'atoms';
import style from './FMColorPicker.style';
import SketchPicker from 'react-color/lib/Sketch';

interface OwnProps {
    initialColor?: string;
    disabled?: boolean;
    onChange?: (value: string) => void;
}

type Props = OwnProps & WithStyles;

interface State {
    selectedColor: string;
    disabled: boolean;
    anchorEl: any;
}

class FMColorPicker extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);

        this.state = {
            selectedColor: this.props.initialColor
                ? this.props.initialColor
                : '#000000',
            disabled: props.disabled ? props.disabled : false,
            anchorEl: null,
        };
    }

    private openPicker = event => {
        this.setState({
            anchorEl: event.currentTarget,
        });
    }

    private handleChangeComplete = (color: any) => {
        this.setState({ selectedColor: color.hex });
        if (this.props.onChange) {
            this.props.onChange(color.hex);
        }
    }

    private handleClose = () => {
        this.setState({
            anchorEl: null,
        });
    }

    public componentWillReceiveProps(nextProps) {
        this.setState({ selectedColor: nextProps.initialColor });
    }

    public render() {
        const { classes } = this.props;
        const { anchorEl } = this.state;
        const open = Boolean(anchorEl);

        return (
            <div className={classes.FMColorPicker}>
                <FMButtonBase
                    onClick={this.openPicker}
                    style={{ backgroundColor: this.state.selectedColor }}
                    className={classes.FMColorPickerButton}
                    disabled={this.state.disabled}
                    aria-owns={open ? 'geoEditColorPopover' : undefined}
                    aria-haspopup="true"
                />
                <Popover
                    id="geoEditColorPopover"
                    open={open}
                    anchorEl={anchorEl}
                    onClose={this.handleClose}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    className={classes.popover}
                >
                    <SketchPicker
                        onChangeComplete={this.handleChangeComplete}
                        color={this.state.selectedColor}
                    />
                </Popover>
            </div>
        );
    }

}

export default withStyles(style)(FMColorPicker);
